import { Button, Divider } from '@material-ui/core'
import React, { useState, useEffect, useRef } from 'react'
import './Message.css'
import CustomInput from '../../components/atoms/Inputs/CustomInput'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import SecondaryButton from '../../components/atoms/SecondaryButton'
import Popup from '../../components/organisms/Popup'
import moment from 'moment'

function Conversations({ conversations, handleMessageSubmit, handleMessageDelete, phrase }) {
    const [message, setMessage] = useState('')
    const [deleteConfirmationPopup, setDeleteConfirmationPopup] = useState(false)
    const [messageId, setMessageId] = useState('')
    const [uploadedFile, setUploadedFile] = useState(null)

    const messageEnd = useRef(null)

    useEffect(() => {
        scrollToBottom()
    }, [conversations])

    const scrollToBottom = () => {
        messageEnd.current?.scrollIntoView({ behavior: 'smooth' })
    }

    const onSubmitMessage = (e) => {
        e.preventDefault()
        if (!message) return
        handleMessageSubmit(message, conversations.sellerid, conversations.projectid, uploadedFile)
        setMessage('')
        setUploadedFile(null)
    }

    const onFileChange = (e) => setUploadedFile(e.target.files[0] || null)

    const isImage = (filename) => {
        if (!filename) return false
        const ext = filename.split('.').pop().toLowerCase()
        return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(ext)
    }

    const renderFilePreview = (conversationForDate) => {
        const fileUrl = `${global.site_url}/uploads/messages/${conversationForDate.img_basename}`
        return isImage(conversationForDate.img_basename) ? (
            <div className="imageConversation">
                <a href={fileUrl} target="_blank" rel="noreferrer">
                    <img src={fileUrl} alt="attachment" />
                </a>
            </div>
        ) : (
            <div className="fileAttachmentBox">
                <div className="fileName">{conversationForDate.img_origname}</div>
                <a href={fileUrl} target="_blank" rel="noreferrer" className="downloadLink">
                    <span className="material-icons" style={{ verticalAlign: 'middle' }}>
                        download
                    </span>{' '}
                    Download
                </a>
            </div>
        )
    }

    const renderMessageRow = (conversationForDate) => {
        const isSender = conversationForDate.from_id !== conversations.sellerid
        const content = (
            <>
                {conversationForDate.image > 0 && renderFilePreview(conversationForDate)}
                {conversationForDate.message && (
                    <p dangerouslySetInnerHTML={{ __html: conversationForDate.message }} />
                )}
            </>
        )

        const time = moment(conversationForDate.date_sent).format('hh:mm A')

        return (
            <div
                className={`messageRow d-flex ${
                    isSender ? 'justify-content-end' : 'justify-content-start'
                } ${conversationForDate.temp ? 'tempMessage' : ''}`}
                key={conversationForDate.id}
            >
                <div className={isSender ? 'messageSent' : 'messageReceived'}>
                    {content}
                    <span className="timeStamp">
                        {time}
                        {conversationForDate.temp && <span></span>}
                    </span>
                </div>
                {isSender && !conversationForDate.temp && (
                    <Button
                        className="deleteMsg"
                        onClick={() => {
                            setMessageId(conversationForDate.id)
                            setDeleteConfirmationPopup(true)
                        }}
                    >
                        <span className="material-icons">delete</span>
                    </Button>
                )}
            </div>
        )
    }

    return (
        <div className="conversations">
            <div className="conversationsCnt">
                {conversations?.actualmessages?.length > 0 ? (
                    conversations.actualmessages.map((conversation) => (
                        <div key={conversation.date}>
                            <div className="dateSent d-flex justify-content-between align-items-center">
                                <Divider />
                                <span>{conversation.date}</span>
                                <Divider />
                            </div>
                            {conversation.datearray.map(renderMessageRow)}
                        </div>
                    ))
                ) : (
                    <div className="noSelection text-center">
                        <span className="material-icons">question_answer</span>
                        <h4>No Conversation Selected</h4>
                    </div>
                )}
                <div style={{ clear: 'both' }} ref={messageEnd}></div>
            </div>

            {uploadedFile && (
                <div className="uploadedImage">
                    <a className="closeImage" onClick={() => setUploadedFile(null)}>
                        <span className="material-icons">highlight_off</span>
                    </a>
                    {isImage(uploadedFile.name) ? (
                        <img
                            src={URL.createObjectURL(uploadedFile)}
                            className="img-thumbnail rounded float-right"
                        />
                    ) : (
                        <div className="fileAttachmentPreview">
                            <span className="material-icons" style={{ verticalAlign: 'middle' }}>
                                attach_file
                            </span>{' '}
                            {uploadedFile.name}
                        </div>
                    )}
                </div>
            )}

            <form className="messageInput" onSubmit={onSubmitMessage}>
                <CustomInput
                    label={phrase.write_a_message}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
                <div className="msgActBtn d-flex justify-content-between align-items-center">
                    <input
                        accept="image/*"
                        className="uploadInput"
                        id="contained-button-file"
                        type="file"
                        onChange={onFileChange}
                    />
                    <label htmlFor="contained-button-file">
                        <Button className="attachBtn" component="span">
                            <span className="material-icons">attach_file</span>
                        </Button>
                    </label>
                    <PrimaryButton label="Send" type="submit" />
                </div>
            </form>

            <Popup
                open={deleteConfirmationPopup}
                handleClose={() => setDeleteConfirmationPopup(false)}
                modaltitle={phrase.delete_confirmation}
                footer={
                    <>
                        <PrimaryButton
                            label={phrase.confirm}
                            onClick={() => {
                                handleMessageDelete(
                                    messageId,
                                    conversations.sellerid,
                                    conversations.projectid,
                                )
                                setDeleteConfirmationPopup(false)
                            }}
                        />
                        <SecondaryButton
                            label={phrase.cancel}
                            onClick={() => setDeleteConfirmationPopup(false)}
                        />
                    </>
                }
            >
                {phrase.confirm_delete_msg}
            </Popup>
        </div>
    )
}

export default Conversations
